import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { TavernInitData } from '@yandex-360/global-bar';

interface DebugInfo {
    env: {
        ENVIRONMENT_TYPE?: string;
        BOX_VERSION?: string;
        IS_ONPREMISE?: string;
        LANDING_AUTH_ENABLED?: string;
        ONPREMLAND_LOCALIZATION_ENABLED?: string;
    };
}

interface ConfigState {
    language: 'ru' | 'en';
    domain: string;
    urlsBase: string;
    environment: string;
    boxVersion: string;
    authEnabled?: boolean;
    userIdHost?: string;
    globalBarInitData?: TavernInitData;
    organizationLogoUrl?: string;
    links: {
        passport: {
            auth: string;
            logout: string;
        };
        documentation: string;
    };
    _debug?: DebugInfo;
}

const initialState: ConfigState = {
    language: 'ru',
    domain: 'example.com',
    urlsBase: 'https://example.com',
    environment: 'production',
    boxVersion: '',
    links: {
        passport: {
            auth: '/auth/login',
            logout: '/auth/logout',
        },
        documentation: '',
    },
};

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setConfig: (state, action: PayloadAction<Partial<ConfigState>>) => {
            return { ...state, ...action.payload };
        },
        setDomain: (state, action: PayloadAction<string>) => {
            state.domain = action.payload;
        },
        setAuthLink: (state, action: PayloadAction<string>) => {
            state.links.passport.auth = action.payload;
        },
        setLogoutLink: (state, action: PayloadAction<string>) => {
            state.links.passport.logout = action.payload;
        },
    },
});

export const { setConfig, setDomain, setAuthLink, setLogoutLink } = configSlice.actions;
export default configSlice.reducer;
